import { Badge, Card, Inline, Stack, Text } from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { formatText } from "@/app/common/functions/format/formatText";

export type NumberedListProps = {
  items: readonly string[];
  ariaLabel?: string;
};

/** Short statements in order, each numbered on its own card. */
export function NumberedList({ items, ariaLabel }: NumberedListProps) {
  return (
    <RevealGroup>
      <Stack as="ol" aria-label={ariaLabel} gap="sm">
        {items.map((item, index) => (
          <RevealItem key={item} as="li">
            <Card size="sm" radius="xl">
              <Inline gap="md">
                <Badge variant="outline" tone="secondary">
                  {String(index + 1).padStart(2, "0")}
                </Badge>
                <Text variant="label" weight="bold">
                  {formatText(item)}
                </Text>
              </Inline>
            </Card>
          </RevealItem>
        ))}
      </Stack>
    </RevealGroup>
  );
}
